import {connect} from 'react-redux';
import _ from 'lodash';

export const connectComponentI18n = componentI18n =>
    connect((state, props) => {
        return {
            i18n: {
                ...(props.i18n || mapI18nFromState(state, props).i18n),
                ...componentI18n[props.eventId ? _.get(`events[${props.eventId}].event.language`, null) || state.i18n.locale : state.i18n.locale],
            },
        };
    });

const mapI18nFromState = (state, props) => ({
    i18n: state.i18n.translations,
});
export const connectI18n = connect(mapI18nFromState);

export const connectEvent = connect((state, props) => ({
    event: props.eventId ? state.events[props.eventId].event : null,
}));

export const connectEventFormDrafts = connect((state, props) => ({
    forms: _(state).get(`events[${props.eventId}].event.forms`, []),
    formDrafts: _(state)
        .chain()
        .get(`events[${props.eventId}].event.forms`, [])
        .map(form => {
            return _(state)
                .chain()
                .get(`forms.drafts`, {})
                .values()
                .filter(draft => draft.eventId == props.eventId && draft.formId == form.id)
                .value();
        })
        .flatten()
        .value(),
}));
